'use client';
import { useState } from 'react';

import { apiCall, ApiCallProps } from '@/utils/fetch';

export function useApi<T>(props: ApiCallProps) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  async function makeApiCall(extraProps: Partial<ApiCallProps> = {}) {
    setLoading(true);
    const response = await apiCall<T>({ ...props, ...extraProps });
    if (response) {
      setData(response.data);
      setError(response.error);
    }
    setLoading(false);

    return response;
  }

  return { data, error, loading, makeApiCall };
}
